import { useState, useEffect } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "../store/ducks/auth/types";

function useIsGerenteOrSuperintendente() {
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const [isGerenteOrSuperintendente, setIsGerenteOrSuperintendente] =
    useState(false);

  useEffect(() => {
    if (codigoCargo2013 !== null) {
      if (
        [
          "219.840.000",
          "219.840.001",
          "219.840.003",
          "219.840.005",
          "219.840.013",
        ].includes(codigoCargo2013)
      ) {
        setIsGerenteOrSuperintendente(true);
      } else {
        setIsGerenteOrSuperintendente(false);
      }
    }
  }, [codigoCargo2013]);

  return isGerenteOrSuperintendente;
}

export default useIsGerenteOrSuperintendente;
